import React, { useState } from "react";
import BookingReportTable from "./Components/BookingReportTable";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";

// Formats a Date object -> "YYYY-MM-DD"
const formatDate = (date) => {
  if (!date) return "";
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const BookingReport = () => {
  const today = new Date();
  const todayStr = formatDate(today);



  // Filters for both modes
  const [checkoutFilters, setCheckoutFilters] = useState({
    checkout_date: `${todayStr} to ${todayStr}`,
  });



  const handleCheckoutDateChange = (e) => {
    const { name, value } = e.target;
    setCheckoutFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };



  const checkoutPickerValue = checkoutFilters.checkout_date
    ? checkoutFilters.checkout_date
      .split(" to ")
      .map((d) => new Date(`${d}T00:00:00`))
    : [today, today];



  return (
    <PageBody
      card={true}
      headerchildren={
        <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 w-100">
          <div>
            <HeadingOne>
              CheckOut Report
            </HeadingOne>
            <p className="text-muted small mb-0">
              View checkout summary filtered by checkout date range
            </p>
          </div>

          {/* Report Type Switcher Tabs */}

        </div>
      }
    >

      <BookingReportTable
        filters={checkoutFilters}
        date={{
          key: "checkout",
          field: {
            name: "checkout_date",
            required: false,
            fieldSize: "p-0",
            placeholder: "Search by Check-Out Date",
            lableHide: true,
          },
          value: checkoutPickerValue,
          handleChange: handleCheckoutDateChange,
          error: "",
          selectMode: "range",
        }}
      />

    </PageBody>
  );
};

export default BookingReport;